import { render, staticRenderFns } from "./OverallPrivilege.vue?vue&type=template&id=1aa01f3c&scoped=true&"
import script from "./OverallPrivilege.vue?vue&type=script&lang=js&"
export * from "./OverallPrivilege.vue?vue&type=script&lang=js&"
import style1 from "./OverallPrivilege.vue?vue&type=style&index=1&id=1aa01f3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa01f3c",
  null
  
)

export default component.exports